"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionTag = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
var ActionTag;
(function (ActionTag) {
    ActionTag["ALL"] = "ALL";
    ActionTag["SOCIAL_MEDIA"] = "SOCIAL_MEDIA";
    ActionTag["JOB_BOARDS"] = "JOB_BOARDS";
    ActionTag["MESSAGING"] = "MESSAGING";
    ActionTag["EMAIL"] = "EMAIL";
    ActionTag["SCRIPTS"] = "SCRIPTS";
    ActionTag["GENERAL"] = "GENERAL";
    ActionTag["OPEN_POSITION"] = "OPEN_POSITION";
    ActionTag["All"] = "ALL";
    ActionTag["SocialMedia"] = "SOCIAL_MEDIA";
    ActionTag["JobBoards"] = "JOB_BOARDS";
    ActionTag["Messaging"] = "MESSAGING";
    ActionTag["Email"] = "EMAIL";
    ActionTag["Scripts"] = "SCRIPTS";
    ActionTag["General"] = "GENERAL";
    ActionTag["OpenPosition"] = "OPEN_POSITION";
})(ActionTag || (exports.ActionTag = ActionTag = {}));
